// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/ProductAllocation.css
// module id = 397
// module chunks = 0